import * as React from 'react';
import { cn } from '@/lib/utils';

export type PocketGeniusVariant = 'talking' | 'listening';

const SRC: Record<PocketGeniusVariant, string> = {
  talking: '/character-system/poses/pocket-genius-phone-00-talking-v1.png',
  listening: '/character-system/poses/pocket-genius-phone-00-listening-v1.png',
};

const ALT: Record<PocketGeniusVariant, string> = {
  talking: 'The Pocket Genius talking',
  listening: 'The Pocket Genius listening',
};

export interface PocketGeniusProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
  variant?: PocketGeniusVariant;
  alt?: string;
}

/**
 * The Pocket Genius — a clever phone-with-face character representing AI.
 * NOT a robot, NOT a tiny human. Race bib 00, race-yellow accent.
 */
export const PocketGenius = React.forwardRef<HTMLImageElement, PocketGeniusProps>(
  ({ variant = 'talking', alt, className, ...rest }, ref) => (
    <img
      ref={ref}
      src={SRC[variant]}
      alt={alt ?? ALT[variant]}
      className={cn('block select-none', className)}
      draggable={false}
      {...rest}
    />
  ),
);
PocketGenius.displayName = 'PocketGenius';
